import React from "react";
import {Button, Input, Modal, Form} from "antd";
import {ModalProps} from "antd/lib/modal";
import {FormInstance} from "antd/lib/form";

interface ModifyModalProps extends ModalProps {
    form: FormInstance
}

export default function DealerNatureEditModal(props: ModifyModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'id'} noStyle>
                    <Input style={{display: 'none'}}/>
                </Form.Item>
                <Form.Item label={'编码'} name={'code'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'客户性质'} name={'dealerNature'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'描述'} name={'desc'} required={true}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}
